import { BUITheme } from "@blofin/blofin-ui";
import { cva } from "class-variance-authority";
import { FC } from "react";
import { textWeight } from "@/nav-localized/config";

const styles = cva("h-[16px] flex items-center justify-center rounded-[4px] ml-[4px]", {
  variants: {
    theme: {
      light: "bg-light-primary",
      dark: "bg-dark-primary"
    }
  }
});

const Hot: FC<{
  theme: BUITheme;
  text?: string;
  className?: string;
  fontSize?: string;
  fontStyle?: string;
  fontClassName?: string;
}> = ({
  theme,
  text = "Hot",
  className = "w-[34px]",
  fontSize = "text-[18px] scale-50",
  fontStyle = "normal",
  fontClassName = textWeight
}) => {
  return (
    <span className={`${styles({ theme })} ${className}`}>
      <span className={`${fontSize} font-bold text-light-label`}>
        <i style={{ fontStyle: fontStyle }} className={fontClassName}>
          {text}
        </i>
      </span>
    </span>
  );
};

export default Hot;
